import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import EventsCalendar from "@/components/EventsCalendar.vue";
import ArticlesSection from "@/components/HomePage/ArticlesSection.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'EventsView',
  setup(__props) {


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(EventsCalendar, { style: {"margin-top":"100px"} }),
    _createVNode(ArticlesSection)
  ], 64))
}
}

})